var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#F38A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 2.37172L4.90942 5.68547C4.90942 5.89516 5.03063 6 5.27305 6H6.7276C6.97002 6 7.09123 5.89516 7.09123 5.68547L7.33366 2.37172C7.33366 2.25735 7.29326 2.17156 7.21245 2.11438C7.15184 2.03813 7.07103 2 6.97002 2H5.03063C4.92962 2 4.83871 2.03813 4.7579 2.11438C4.6973 2.17156 4.66699 2.25735 4.66699 2.37172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 7.33594C6.36748 7.33594 6.67665 7.4712 6.92786 7.74173C7.19839 7.99294 7.33366 8.30212 7.33366 8.66927C7.33366 9.03642 7.19839 9.35526 6.92786 9.62579C6.67665 9.877 6.36748 10.0026 6.00033 10.0026C5.63318 10.0026 5.31434 9.877 5.0438 9.62579C4.7926 9.35526 4.66699 9.03642 4.66699 8.66927C4.66699 8.30212 4.7926 7.99294 5.0438 7.74173C5.31434 7.4712 5.63318 7.33594 6.00033 7.33594Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5bc067715e0802a7a8e4401192f608cb.svg";
export { ForwardRef as ReactComponent };